import { PageLink } from '../../../../../../_metronic/layout/core'

export const breadCrumbs: Array<PageLink> = [
  {
    title: 'Аудит интеграций',
    path: '/logs/audit',
    isSeparator: false,
    isActive: true,
  },
]

export const DIRECTION_OPTIONS = [
  { value: '', label: 'Все направления' },
  { value: 'in', label: 'Входящий (in)' },
  { value: 'out', label: 'Исходящий (out)' },
]

export const TOPIC_OPTIONS = [
  { value: 'provider', label: 'Провайдеры' },
  { value: 'merchant', label: 'Мерчанты' },
]

export const SEARCH_FIELD_OPTIONS = [
  { label: 'ID тикета', value: 'ticket_token' },
  { label: 'ID транзакции', value: 'transaction_id' },
  { label: 'ID адаптера', value: 'payment_id' },
] as const
